<style src="./CreateZone.scss" lang="scss"></style>
<template>
  <div class="wrapper wrapper-content animated fadeIn">
    <div class="row">
      <div class="col-lg-5">
        <div class="ibox float-e-margins">
          <div class="ibox-content mailbox-content">
            <form v-on:submit.prevent>
              <h2>Cadastro de Zona</h2>
              <div class="space-25"></div>

              <div class="form-group">
                <label>Nome</label>
                <input
                  type="text"
                  placeholder="Lado B"
                  class="form-control"
                  v-model="registerForm.form.name"
                />
              </div>

              <div class="form-group">
                <label>Tolerancia</label>
                <input
                  type="Number"
                  placeholder="0"
                  class="form-control"
                  v-model="registerForm.form.continuousTolerance"
                />
              </div>

              <button
                class="btn btn-block btn-primary compose-mail"
                href="mail_compose.html"
                :disabled="
                  registerForm.form.parks.length < 2 ||
                    !permissionCreate ||
                    registerForm.control.createButtonIsDisabled
                "
                v-if="!registerForm.control.editModeId"
              >
                <i class="fa fa-save"></i>
                Criar Zona
              </button>

              <div v-if="registerForm.control.editModeId">
                <button
                  class="btn btn-outline"
                  href="mail_compose.html"
                  :disabled="registerForm.control.createButtonIsDisabled"
                  type="button"
                  @click="disableEditMode"
                >
                  Cancelar
                </button>

                <button
                  class="btn btn-warning pull-right"
                  href="mail_compose.html"
                  :disabled="
                    registerForm.control.createButtonIsDisabled ||
                      !permissionUpdate
                  "
                  @click="saveEdition"
                >
                  <i class="fa fa-save"></i>
                  Salvar Edição
                </button>
              </div>
            </form>
          </div>
        </div>

        <div class="ibox-content mailbox-content" v-if="permissionRead">
          <h2>Lista de Zonas</h2>
          <table class="table table-hover table-mail">
            <thead class="table-head">
              <tr>
                <th>Nome</th>

                <th></th>
                <th></th>
              </tr>
            </thead>

            <tbody class="table-list">
              <tr v-for="(listItem, listIdx) in zonesList" :key="listIdx">
                <td>{{ listItem.name }}</td>

                <td class="list-command">
                  <button
                    class="btn btn-outline"
                    @click="enterEditMode(listItem)"
                    v-if="permissionUpdate"
                  >
                    <i class="fa fa-edit text-success"></i>
                  </button>
                </td>
                <td class="list-command">
                  <button
                    class="btn btn-outline"
                    @click="deleteZone(listItem._id)"
                    v-if="permissionDelete"
                  >
                    <i class="fa fa-trash text-danger"></i>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div class="col-lg-7 animated fadeInRight">
        <div class="mail-box-header">
          <h2>Lista de Estacionamentos</h2>

          <form>
            <div class="input-group">
              <input
                type="text"
                class="form-control"
                v-model="searchForm.form.parkName"
              />

              <div class="input-group-btn">
                <button
                  type="button"
                  class="btn btn-sm btn-primary"
                  @click="searchParks"
                  v-if="permissionRead"
                >
                  <i class="fa fa-search"></i>
                  Buscar
                </button>
              </div>
            </div>
          </form>
        </div>
        <div class="mail-box">
          <table class="table table-hover table-mail">
            <thead class="table-head">
              <tr>
                <th>Nome</th>
                <th>Total de vagas</th>
                <th></th>
              </tr>
            </thead>

            <tbody class="table-list">
              <tr v-for="(listItem, listIdx) in parksList.list" :key="listIdx">
                <td>{{ listItem.parkName }}</td>
                <td>{{ listItem.parkingSpaceCount }}</td>

                <td class="list-command">
                  <div class="form-check">
                    <input
                      type="checkbox"
                      class="form-check-input"
                      v-model="registerForm.form.parks"
                      :value="listItem._id"
                    />
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RegisterZones',

  data() {
    return {
      registerForm: {
        form: {
          name: '',
          continuousTolerance: '',
          parks: [],
        },
        control: {
          editModeId: false,
          createButtonIsDisabled: false,
          roleList: [],
        },
      },
      searchForm: {
        form: {
          parkName: '',
        },
        control: {},
      },
      parksList: {
        originalList: [],
        list: [],
        control: {},
      },
      zonesList: [],
    };
  },
  computed: {
    permissionCreate() {
      return this.$store.getters['DATA-ACCESS/HasAccess'](
        'create-zone',
        'CREATE',
      );
    },
    permissionRead() {
      return this.$store.getters['DATA-ACCESS/HasAccess'](
        'create-zone',
        'READ',
      );
    },
    permissionUpdate() {
      return this.$store.getters['DATA-ACCESS/HasAccess'](
        'create-zone',
        'UPDATE',
      );
    },
    permissionDelete() {
      return this.$store.getters['DATA-ACCESS/HasAccess'](
        'create-zone',
        'DELETE',
      );
    },
  },
  watch: {
    'searchForm.form.parkName'() {
      this.searchParks();
    },
  },
  mounted() {
    this.ListParks();
    this.listRoles();
    this.listZones();
  },
  methods: {
    async listRoles() {
      const list = await this.$store.dispatch('ROLES/ListRoles');
      this.registerForm.control.roleList = list;
    },
    async ListParks() {
      if (!this.permissionRead) {
        return;
      }
      const parksList = await this.$store.dispatch('PARKING/GetParkList');
      this.parksList.originalList = parksList;
      this.searchParks();
    },
    searchParks() {
      if (!this.permissionRead) {
        return;
      }

      const listFiltered = this.parksList.originalList.filter(item => {
        return (
          item.parkName
            .toUpperCase()
            .indexOf(this.searchForm.form.parkName.toUpperCase()) > -1
        );
      });
      this.parksList.list = listFiltered;
    },
    async createZone() {
      if (!this.permissionCreate) {
        return;
      }

      if (
        this.registerForm.form.name.length === 0 ||
        this.registerForm.form.parks.length === 0
      ) {
        return;
      }
      this.registerForm.control.createButtonIsDisabled = true;

      const payload = {
        ...this.registerForm.form,
      };

      try {
        await this.$store.dispatch('ZONE/CreateNewZone', payload);
        this.ListParks();

        this.registerForm.form.name = '';
        this.registerForm.form.continuousTolerance = '';
        this.registerForm.form.parks = [];

        this.$toasted.success('Zona castrada com sucesso');
      } catch (error) {
        this.$toasted.error('Não foi possível criar a zona');
      } finally {
        this.registerForm.control.createButtonIsDisabled = false;
      }
    },
    async listZones() {
      try {
        const zones = await this.$store.dispatch('ZONE/ListAll');
        this.zonesList = zones;
      } catch (error) {
        this.$toasted.error('Não foi possivél listar as zonas');
      }
    },
    enterEditMode(zone) {
      this.registerForm.control.editModeId = zone._id;
      this.registerForm.form.name = zone.name;
      this.registerForm.form.continuousTolerance = zone.continuousTolerance;
      this.registerForm.form.parks = zone.parks.map(park => park._id);
    },
    disableEditMode() {
      this.registerForm.control.editModeId = false;
      this.registerForm.form.name = '';
      this.registerForm.form.continuousTolerance = '';
      this.registerForm.form.parks = [];
    },
    async deleteZone(zoneId) {
      this.registerForm.control.createButtonIsDisabled = true;

      try {
        await this.$store.dispatch('ZONE/DeleteZone', zoneId);
        this.listZones();

        this.$toasted.success('Zona deletada com sucesso');
      } catch (error) {
        this.$toasted.error(error.error);
      } finally {
        this.registerForm.control.createButtonIsDisabled = false;
      }
    },
    async saveEdition() {
      if (
        this.registerForm.form.name.length === 0 ||
        this.registerForm.form.continuousTolerance.length === 0 ||
        this.registerForm.form.parks.length === 0
      ) {
        return;
      }
      this.registerForm.control.createButtonIsDisabled = true;

      const zoneId = this.registerForm.control.editModeId;

      const payload = {
        ...this.registerForm.form,
      };

      try {
        await this.$store.dispatch('ZONE/UpdateZone', {
          payload,
          zoneId,
        });
        this.listZones();

        this.registerForm.form.name = '';
        this.registerForm.form.continuousTolerance = '';
        this.registerForm.form.parks = [];

        this.$toasted.success('Zona salva com sucesso');
      } catch (error) {
        this.$toasted.error(error.error);
      } finally {
        this.registerForm.control.createButtonIsDisabled = false;
      }
    },
  },
};
</script>
